import React from "react";
import { LogoMark } from "./Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-gray-200 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <LogoMark />
            <p className="text-sm text-[#4B5563] mt-4 max-w-xs leading-relaxed">
              Movimiento ciudadano por el Capitalismo de Abundancia. Patrimonio, soberanía y futuro
              para cada argentino.
            </p>
          </div>
          <div>
            <h4 className="font-headings uppercase tracking-[0.2em] text-xs text-[#0A192F] mb-4">
              Navegación
            </h4>
            <ul className="space-y-2 text-sm text-[#4B5563]">
              <li><a href="#doctrina" className="hover:text-[#0A2463]">Doctrina</a></li>
              <li><a href="#simulador" className="hover:text-[#0A2463]">Capital Ciudadano</a></li>
              <li><a href="#politicas" className="hover:text-[#0A2463]">10 Políticas</a></li>
              <li><a href="#libro" className="hover:text-[#0A2463]">El libro</a></li>
              <li><a href="#prensa" className="hover:text-[#0A2463]">Prensa</a></li>
              <li><a href="#sumate" className="hover:text-[#0A2463]">Sumate</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-headings uppercase tracking-[0.2em] text-xs text-[#0A192F] mb-4">
              Movimiento
            </h4>
            <p className="text-sm text-[#4B5563] leading-relaxed">
              Frente Ya — ImPosible Ya↑<br />
              Capitalismo de Abundancia<br />
              <span className="text-[#9CA3AF]">Argentina · {year}</span>
            </p>
            <p className="mt-4 text-xs text-[#9CA3AF] italic">
              "La Nación que aprendió a sobrevivir ahora va a aprender a abundar."
            </p>
            <a
              href="mailto:prensa@frenteya.com.ar"
              className="mt-4 inline-block text-xs uppercase tracking-[0.2em] text-[#0A2463] hover:text-[#F5B400] font-headings"
              data-testid="footer-press-link"
            >
              prensa@frenteya.com.ar
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-200 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#9CA3AF]">
          <span>© {year} Frente Ya — Todos los derechos reservados.</span>
          <span className="font-headings tracking-[0.2em] uppercase">
            Menos promesas · <span className="text-[#F5B400]">más resultados</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
